import React, { useState, useEffect } from 'react';
import '../Formulario/Formulario.css';
import Categorias from '../sidebar/Categorias';
import { getAuthToken } from '../utils/auth';
import BASE_URL from '../utils/api';
import BotaoVoltarTopo from '../components/BotaoVoltarTopo';

export default function FormularioProduto({ produto, onSalvar, onCancelar }) {
  const [formData, setFormData] = useState({
    nome: '',
    descricao: '',
    preco: '',
    categoriaProdutoId: '',
    estoque: '',
    estoqueFisico: '',
    estoqueReservado: '',
    estoqueMinimo: '',
    unidade: 'UN',
    codigoBarras: '',
    ativo: true,
    dataCadastro: new Date().toISOString().split('T')[0],
    dataUltimaMovimentacao: '',
    // Campos Fiscais
    ncm: '',
    gtin: '',
    cfop: '5102',
    cest: '',
    unidadeTributaria: 'UN',
    origemMercadoria: '0',
    // ICMS
    aliquotaICMS: '0',
    cst_ICMS: '00',
    csosn: '102',
    modalidadeBCICMS: '3',
    percentualReducaoBC: '0',
    // ICMS-ST
    aliquotaICMS_ST: '0',
    mva_ST: '0',
    // IPI
    aliquotaIPI: '0',
    cst_IPI: '99',
    codigoEnquadramentoIPI: '999',
    // PIS
    aliquotaPIS: '0',
    cst_PIS: '99',
    // COFINS
    aliquotaCOFINS: '0',
    cst_COFINS: '99',
    // Peso e Dimensões
    pesoLiquido: '0',
    pesoBruto: '0',
    altura: '',
    largura: '',
    profundidade: '',
    // FCP e Info
    aliquotaFCP: '0',
    beneficioFiscal: '',
    informacoesAdicionaisProduto: '',
    // UI/Produção
    ufProducao: '',
    regimeTributario: 'simples'
  });
  const [mostrarFiscal, setMostrarFiscal] = useState(false);
  const [possuiCodigoBarras, setPossuiCodigoBarras] = useState(false);
  const [adicionarMedidas, setAdicionarMedidas] = useState(false);

  const [loading, setLoading] = useState(false);
  // Foto do produto escolhida no formulário (enviada ao salvar)
  const [fotoArquivo, setFotoArquivo] = useState(null);
  const [categorias, setCategorias] = useState([]);
  const [mostrarCategorias, setMostrarCategorias] = useState(false);

  useEffect(() => {
    if (produto) {
      setFormData({
        nome: produto.nome || '',
        descricao: produto.descricao || '',
        preco: produto.preco?.toString() || '',
        categoriaProdutoId: (produto.categoriaProdutoId !== undefined && produto.categoriaProdutoId !== null) ? String(produto.categoriaProdutoId) : (produto.categoriaId ? String(produto.categoriaId) : (produto.categoria ? String(produto.categoria) : '')),
        estoque: produto.estoque?.toString() || '',
        estoqueFisico: produto.estoqueFisico?.toString() || '',
        estoqueReservado: produto.estoqueReservado?.toString() || '',
        estoqueMinimo: produto.estoqueMinimo?.toString() || '',
        unidade: produto.unidade || 'UN',
        codigoBarras: produto.codigoBarras || '',
        ativo: produto.ativo !== false,
        dataCadastro: produto.dataCadastro ? produto.dataCadastro.split('T')[0] : new Date().toISOString().split('T')[0],
        dataUltimaMovimentacao: produto.dataUltimaMovimentacao ? produto.dataUltimaMovimentacao.split('T')[0] : '',
        // Campos Fiscais
        ncm: produto.ncm || produto.NCM || '',
        gtin: produto.gtin || produto.GTIN || '',
        cfop: produto.cfop || produto.CFOP || '5102',
        cest: produto.cest || produto.CEST || '',
        unidadeTributaria: produto.unidadeTributaria || produto.UnidadeTributaria || 'UN',
        origemMercadoria: (produto.origemMercadoria ?? produto.OrigemMercadoria ?? 0).toString(),
        aliquotaICMS: (produto.aliquotaICMS ?? produto.AliquotaICMS ?? 0).toString(),
        cst_ICMS: produto.csT_ICMS || produto.CST_ICMS || produto.cst_ICMS || '00',
        csosn: produto.csosn || produto.CSOSN || '102',
        modalidadeBCICMS: (produto.modalidadeBCICMS ?? produto.ModalidadeBCICMS ?? 3).toString(),
        percentualReducaoBC: (produto.percentualReducaoBC ?? produto.PercentualReducaoBC ?? 0).toString(),
        aliquotaICMS_ST: (produto.aliquotaICMS_ST ?? produto.AliquotaICMS_ST ?? 0).toString(),
        mva_ST: (produto.mvA_ST ?? produto.mva_ST ?? produto.MVA_ST ?? 0).toString(),
        aliquotaIPI: (produto.aliquotaIPI ?? produto.AliquotaIPI ?? 0).toString(),
        cst_IPI: produto.csT_IPI || produto.CST_IPI || produto.cst_IPI || '99',
        codigoEnquadramentoIPI: produto.codigoEnquadramentoIPI || produto.CodigoEnquadramentoIPI || '999',
        aliquotaPIS: (produto.aliquotaPIS ?? produto.AliquotaPIS ?? 0).toString(),
        cst_PIS: produto.csT_PIS || produto.CST_PIS || produto.cst_PIS || '99',
        aliquotaCOFINS: (produto.aliquotaCOFINS ?? produto.AliquotaCOFINS ?? 0).toString(),
        cst_COFINS: produto.csT_COFINS || produto.CST_COFINS || produto.cst_COFINS || '99',
        pesoLiquido: (produto.pesoLiquido ?? produto.PesoLiquido ?? 0).toString(),
        pesoBruto: (produto.pesoBruto ?? produto.PesoBruto ?? 0).toString(),
        altura: (produto.altura ?? produto.Altura ?? '').toString(),
        largura: (produto.largura ?? produto.Largura ?? '').toString(),
        profundidade: (produto.profundidade ?? produto.Profundidade ?? '').toString(),
        aliquotaFCP: (produto.aliquotaFCP ?? produto.AliquotaFCP ?? 0).toString(),
        beneficioFiscal: produto.beneficioFiscal || produto.BeneficioFiscal || '',
        informacoesAdicionaisProduto: produto.informacoesAdicionaisProduto || produto.InformacoesAdicionaisProduto || '',
        ufProducao: produto.ufProducao || produto.UFProducao || '',
        regimeTributario: produto.regimeTributario || 'simples'
      });
      setPossuiCodigoBarras(!!(produto.codigoBarras || produto.CodigoBarras));
      setAdicionarMedidas(!!(produto.altura || produto.Altura || produto.largura || produto.Largura || produto.profundidade || produto.Profundidade));
    }
  }, [produto]);

  const recarregarCategorias = () => {
    const urls = [`${BASE_URL}/CategoriaProduto`, `${BASE_URL}/CategoriaProduto`];
    const tryNext = (i) => {
      if (i >= urls.length) return;
      const token = getAuthToken();
      const headers = token ? { 'Authorization': 'Bearer ' + token } : {};
      fetch(urls[i], { headers })
        .then(r => { if (!r.ok) throw new Error(); return r.json(); })
        .then(data => setCategorias(Array.isArray(data) ? data : []))
        .catch(() => tryNext(i + 1));
    };
    tryNext(0);
  };

  useEffect(() => {
    recarregarCategorias();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => {
      const updated = {
        ...prev,
        [name]: type === 'checkbox' ? checked : value
      };
      // GTIN é o mesmo que código de barras (EAN/UPC) — auto-sincroniza
      if (name === 'codigoBarras') updated.gtin = value;
      // Limpar UF de Produção quando origem mudar para importada (1, 2, 6, 7)
      if (name === 'origemMercadoria' && ['1','2','6','7'].includes(value)) {
        updated.ufProducao = '';
      }
      return updated;
    });
  };

  // Função para fazer chamadas da API usando o BASE_URL configurado
  const apiCall = async (endpoint, options = {}) => {
    const apiBases = [
      BASE_URL,
      BASE_URL.replace(/\/$/, ''),
      BASE_URL.replace(/\/api\/?$/, ''),
      `${BASE_URL.replace(/\/api\/?$/, '')}/api`
    ].filter(Boolean);

    for (const base of apiBases) {
      const url = base.endsWith('/') ? `${base}${endpoint}` : `${base}/${endpoint}`;
      try {
        console.log(`Tentando conectar em: ${url}`);
        const token = getAuthToken();
        const optionsWithAuth = { ...options, headers: { ...(options.headers || {})} };
        if (token) optionsWithAuth.headers['Authorization'] = 'Bearer ' + token;
        const response = await fetch(url, optionsWithAuth);
        // Log response status and body (clone so caller can still read it)
        try {
          const bodyText = await response.clone().text();
          console.log(`Resposta de ${url} - Status: ${response.status}, Body:`, bodyText);
        } catch (readErr) {
          console.log(`Resposta de ${url} - Status: ${response.status} (body leitura falhou: ${readErr.message})`);
        }

        if (response.ok) {
          console.log(`✅ Sucesso em: ${url}`);
          return response;
        }
        console.log(`❌ Falha em: ${url} - Status: ${response.status}`);
      } catch (error) {
        console.log(`❌ Erro em: ${url} - ${error.message}`);
      }
    }

    throw new Error('Nenhuma URL da API funcionou. Verifique se o backend está rodando.');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const method = produto ? 'PUT' : 'POST';
      const endpoint = produto ? `Produto/${produto.id}` : 'Produto';
      // Always send product ID in body for PUT
      // Build payload matching backend Produto model (PascalCase names)
      const payload = {
        Nome: formData.nome || '',
        Preco: parseFloat(formData.preco) || 0,
        CategoriaProdutoId: formData.categoriaProdutoId ? parseInt(formData.categoriaProdutoId) : null,
        Estoque: parseInt(formData.estoque) || 0,
        EstoqueFisico: parseInt(formData.estoqueFisico) || 0,
        EstoqueReservado: parseInt(formData.estoqueReservado) || 0,
        EstoqueMinimo: parseInt(formData.estoqueMinimo) || 0,
        Unidade: formData.unidade || 'UN',
        CodigoBarras: formData.codigoBarras || null,
        Categoria: formData.categoria || null,
        Ativo: !!formData.ativo,
        DataCadastro: formData.dataCadastro || new Date().toISOString(),
        DataUltimaMovimentacao: formData.dataUltimaMovimentacao || null,
        // Campos Fiscais
        NCM: formData.ncm || null,
        GTIN: formData.gtin || null,
        CFOP: formData.cfop || '5102',
        CEST: formData.cest || null,
        UnidadeTributaria: formData.unidadeTributaria || 'UN',
        OrigemMercadoria: parseInt(formData.origemMercadoria) || 0,
        // ICMS
        AliquotaICMS: parseFloat(formData.aliquotaICMS) || 0,
        CST_ICMS: formData.cst_ICMS || '00',
        CSOSN: formData.csosn || '102',
        ModalidadeBCICMS: parseInt(formData.modalidadeBCICMS) || 3,
        PercentualReducaoBC: parseFloat(formData.percentualReducaoBC) || 0,
        // ICMS-ST
        AliquotaICMS_ST: parseFloat(formData.aliquotaICMS_ST) || 0,
        MVA_ST: parseFloat(formData.mva_ST) || 0,
        // IPI
        AliquotaIPI: parseFloat(formData.aliquotaIPI) || 0,
        CST_IPI: formData.cst_IPI || '99',
        CodigoEnquadramentoIPI: formData.codigoEnquadramentoIPI || '999',
        // PIS
        AliquotaPIS: parseFloat(formData.aliquotaPIS) || 0,
        CST_PIS: formData.cst_PIS || '99',
        // COFINS
        AliquotaCOFINS: parseFloat(formData.aliquotaCOFINS) || 0,
        CST_COFINS: formData.cst_COFINS || '99',
        // Peso e Dimensões
        PesoLiquido: parseFloat(formData.pesoLiquido) || 0,
        PesoBruto: parseFloat(formData.pesoBruto) || 0,
        Altura: formData.altura ? parseFloat(formData.altura) : null,
        Largura: formData.largura ? parseFloat(formData.largura) : null,
        Profundidade: formData.profundidade ? parseFloat(formData.profundidade) : null,
        // FCP e Info
        AliquotaFCP: parseFloat(formData.aliquotaFCP) || 0,
        BeneficioFiscal: formData.beneficioFiscal || null,
        InformacoesAdicionaisProduto: formData.informacoesAdicionaisProduto || null,
        UFProducao: formData.ufProducao || null
      };
      if (produto && produto.id) payload.Id = produto.id;
      console.log('📤 Enviando para endpoint:', endpoint, 'Payload (backend shape):', payload);
      // Try direct known backend URLs first for Produto endpoints (gives clearer failures)
      const sendProdutoRequest = async () => {
        const directUrls = [
          `${BASE_URL}/${endpoint}`,
          `${BASE_URL}/${endpoint}`,
          `${BASE_URL}/${endpoint}`,
          `${BASE_URL}/${endpoint}`
        ];

        for (const url of directUrls) {
          try {
            console.log('Tentando POST direto em:', url);
            const token = getAuthToken();
            const resp = await fetch(url, {
              method: method,
              headers: { 'Content-Type': 'application/json', ...(token ? {'Authorization': 'Bearer ' + token} : {}) },
              body: JSON.stringify(payload)
            });
            try { const t = await resp.clone().text(); console.log(`Resposta direta ${url}:`, resp.status, t); } catch {}
            if (resp.ok) return resp;
          } catch (err) {
            console.log('Erro direto em', url, err.message || err);
          }
        }

        // fallback to the generic apiCall (keeps existing behavior)
        return await apiCall(endpoint, {
          method: method,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
      };

      const response = await sendProdutoRequest();
      // Exibir erro do backend mesmo se não for ok
      if (response) {
        let resultText = '';
        try { resultText = await response.text(); } catch {}
        if (response.ok) {
          // Foto escolhida: envia depois de salvar (na criação, o id vem na resposta)
          if (fotoArquivo) {
            let produtoId = produto?.id;
            if (!produtoId) { try { produtoId = JSON.parse(resultText)?.id; } catch { /* sem corpo */ } }
            if (produtoId) {
              const dados = new FormData();
              dados.append('arquivo', fotoArquivo);
              const respFoto = await fetch(`${BASE_URL}/Produto/${produtoId}/foto`, { method: 'POST', body: dados });
              if (!respFoto.ok) {
                let msg = '';
                try { msg = (await respFoto.json())?.mensagem; } catch { /* texto simples */ }
                alert(`O produto foi salvo, mas a foto não: ${msg || `erro ${respFoto.status}`}`);
              }
            }
            setFotoArquivo(null);
          }
          alert(produto ? 'Produto atualizado com sucesso!' : 'Produto criado com sucesso!');
          onSalvar && onSalvar();
        } else {
          // show backend error text when available
          const mensagem = resultText ? `Erro ${response.status}: ${resultText}` : `Erro ${response.status}: sem mensagem`;
          throw new Error(mensagem);
        }
      } else {
        throw new Error('Nenhuma resposta do backend.');
      }
    } catch (err) {
      console.error('Erro ao salvar produto:', err);
      alert(`Erro ao salvar produto: ${err.message.replace('Error','Erro')}`);
    } finally {
      setLoading(false);
    }
  };

  const handleCancelar = () => {
    setFormData({
      nome: '', descricao: '', preco: '', categoriaProdutoId: '',
      estoque: '', estoqueFisico: '', estoqueReservado: '', estoqueMinimo: '',
      unidade: 'UN', codigoBarras: '', ativo: true,
      dataCadastro: new Date().toISOString().split('T')[0], dataUltimaMovimentacao: '',
      ncm: '', gtin: '', cfop: '5102', cest: '', unidadeTributaria: 'UN', origemMercadoria: '0',
      aliquotaICMS: '0', cst_ICMS: '00', csosn: '102', modalidadeBCICMS: '3', percentualReducaoBC: '0',
      aliquotaICMS_ST: '0', mva_ST: '0',
      aliquotaIPI: '0', cst_IPI: '99', codigoEnquadramentoIPI: '999',
      aliquotaPIS: '0', cst_PIS: '99',
      aliquotaCOFINS: '0', cst_COFINS: '99',
      pesoLiquido: '0', pesoBruto: '0', altura: '', largura: '', profundidade: '',
      aliquotaFCP: '0', beneficioFiscal: '', informacoesAdicionaisProduto: '',
      ufProducao: '', regimeTributario: 'simples'
    });
    setMostrarFiscal(false);
    setPossuiCodigoBarras(false);
    setAdicionarMedidas(false);
    onCancelar && onCancelar();
  };

  return (
    <div className="popup-agendamento-overlay">
      <div className="popup-agendamento" onClick={e => e.stopPropagation()} style={{ position: 'relative' }}>
        <BotaoVoltarTopo />
        <div className="popup-agendamento-centro">
          <button
            onClick={handleCancelar}
            aria-label="Fechar"
            style={{
              position: 'absolute',
              top: '10px',
              right: '10px',
              backgroundColor: 'rgb(235, 133, 0)',
              color: 'white',
              border: 'none',
              borderRadius: '50%',
              width: '30px',
              height: '30px',
              fontSize: '18px',
              fontWeight: 'bold',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1000
            }}
          >
            ×
          </button>
          <div className="popup-titulo-laranja">
            {produto ? 'Editar Produto' : 'Novo Produto'}
          </div>
          
          <form id="produto-form-dados" onSubmit={handleSubmit} style={{ width: '100%', maxWidth: '700px' }}>
            {/* Nome do Produto */}
            <div style={{ marginBottom: '16px' }}>
              <label style={{ color: 'black', fontWeight: 'bold', display: 'block', marginBottom: '8px' }}>
                Nome do Produto: *
              </label>
              <input
                type="text"
                name="nome"
                value={formData.nome}
                onChange={handleInputChange}
                required
                disabled={loading}
                style={{
                  width: '100%',
                  padding: '8px',
                  borderRadius: '5px',
                  border: '1px solid #ccc',
                  background: 'white'
                }}
              />
            </div>

            {/* Foto do produto (uma só): é enviada ao salvar; aparece no card da listagem */}
            <div style={{ marginBottom: '16px', display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
              <label style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '8px 14px', borderRadius: 6, background: 'rgb(235, 133, 0)', color: '#fff', fontWeight: 600, fontSize: 14, cursor: loading ? 'not-allowed' : 'pointer' }}>
                📷 {produto?.temFoto || fotoArquivo ? 'Trocar foto do produto' : 'Foto do produto'}
                <input
                  type="file"
                  accept="image/*"
                  disabled={loading}
                  style={{ display: 'none' }}
                  onChange={(e) => {
                    const arquivo = e.target.files?.[0];
                    e.target.value = '';
                    if (!arquivo) return;
                    if (!arquivo.type.startsWith('image/')) { alert('Escolha uma imagem (JPG, PNG, WEBP...).'); return; }
                    if (arquivo.size > 5 * 1024 * 1024) { alert('A imagem pode ter no máximo 5 MB.'); return; }
                    setFotoArquivo(arquivo);
                  }}
                />
              </label>
              <span style={{ fontSize: 13, color: '#666' }}>
                {fotoArquivo ? `Nova foto: ${fotoArquivo.name} (salva ao clicar em Salvar)` : (produto?.temFoto ? 'Este produto já tem foto.' : 'Sem foto.')}
              </span>
            </div>

            {/* Descrição */}
            <div style={{ marginBottom: '16px' }}>
              <label style={{ color: 'black', fontWeight: 'bold', display: 'block', marginBottom: '8px' }}>
                Descrição:
              </label>
              <textarea
                name="descricao"
                value={formData.descricao}
                onChange={handleInputChange}
                rows="3"
                disabled={loading}
                style={{
                  width: '100%',
                  padding: '8px',
                  borderRadius: '5px',
                  border: '1px solid #ccc',
                  background: 'white'
                }}
              />
            </div>

            {/* Categoria */}
            <div style={{ marginBottom: '16px' }}>
              <label style={{ color: 'black', fontWeight: 'bold', display: 'block', marginBottom: '8px' }}>
                Categoria:
              </label>
              <select
                name="categoriaProdutoId"
                value={formData.categoriaProdutoId}
                onChange={handleInputChange}
                disabled={loading}
                style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', background: 'white', fontSize: '14px' }}
              >
                <option value="">Selecione uma categoria</option>
                {categorias && categorias.length > 0 ? (
                  categorias.map(c => (
                    <option key={c.id} value={c.id}>{c.descricao}</option>
                  ))
                ) : (
                  <option value="">(Sem categorias)</option>
                )}
              </select>

              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginTop: '10px' }}>
                <button
                  type="button"
                  onClick={() => setMostrarCategorias(prev => !prev)}
                  style={{
                    backgroundColor: 'rgb(235, 133, 0)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    padding: '8px 12px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: 'bold'
                  }}
                >
                  {mostrarCategorias ? 'Ocultar Categorias' : 'Gerenciar Categorias'}
                </button>
                <span style={{ color: '#666', fontSize: '13px' }}>
                  {mostrarCategorias ? 'Selecione uma categoria ou feche o painel.' : 'Clique para editar/adicionar categorias'}
                </span>
              </div>
              {mostrarCategorias && (
                <div style={{
                  marginTop: '14px',
                  backgroundColor: '#fff',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  padding: '16px',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                }}>
                  <Categorias onMudanca={recarregarCategorias} />
                </div>
              )}
            </div>

            {/* Preço e Unidade */}
            <div style={{ display: 'flex', gap: '20px', marginBottom: '16px' }}>
              <div style={{ flex: 0.2 }}>
                <label style={{ color: 'black', fontWeight: 'bold', display: 'block', marginBottom: '8px' }}>
                  Preço (R$): *
                </label>
                <input
                  type="number"
                  name="preco"
                  value={formData.preco}
                  onChange={handleInputChange}
                  step="0.01"
                  min="0"
                  required
                  disabled={loading}
                  style={{
                    width: '100%',
                    padding: '8px',
                    borderRadius: '5px',
                    border: '1px solid #ccc',
                    background: 'white'
                  }}
                  placeholder="R$ 0,00"
                />
              </div>

              <div style={{ flex: 0.25 }}>
                <label style={{ color: 'black', fontWeight: 'bold', display: 'block', marginBottom: '8px' }}>
                  Unidade:
                </label>
                <select
                  name="unidade"
                  value={formData.unidade}
                  onChange={handleInputChange}
                  disabled={loading}
                  style={{
                    width: '100%',
                    padding: '8px',
                    borderRadius: '5px',
                    border: '1px solid #ccc',
                    background: 'white'
                  }}
                >
                  <option value="UN">Unidade (UN)</option>
                  <option value="KG">Quilograma (KG)</option>
                  <option value="G">Grama (G)</option>
                  <option value="L">Litro (L)</option>
                  <option value="ML">Mililitro (ML)</option>
                  <option value="M">Metro (M)</option>
                  <option value="CM">Centímetro (CM)</option>
                  <option value="M2">Metro Quadrado (M²)</option>
                  <option value="M3">Metro Cúbico (M³)</option>
                  <option value="CX">Caixa (CX)</option>
                  <option value="PC">Peça (PC)</option>
                  <option value="PAR">Par (PAR)</option>
                </select>
              </div>
            </div>

            {/* Controle de Estoque */}
            <div id="produto-form-estoque" style={{ marginBottom: '16px', background: '#fff8e1', padding: '16px', borderRadius: '8px', border: '1px solid #ffcc80' }}>
              <h4 style={{ color: 'black', marginBottom: '12px', fontSize: '16px' }}>Controle de Estoque</h4>

              {/* Estoque Disponível - não editável, mostra a coluna `estoque` */}
              <div style={{ marginBottom: '12px', width: '33%', minWidth: '140px' }}>
                <label style={{ color: '#333', fontWeight: 'bold', display: 'block', marginBottom: '8px' }}>
                  Estoque Disponível:
                </label>
                <input
                  type="number"
                  name="estoque"
                  value={formData.estoque}
                  onChange={handleInputChange}
                  disabled={true}
                  readOnly
                  style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', background: '#f5f5f5', boxSizing: 'border-box' }}
                />
              </div>

              {/* Linha com Estoque Físico / Reservado / Mínimo - mesma largura */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '24px', marginTop: '8px' }}>
                <div>
                  <label style={{ color: '#333', fontWeight: 'bold', display: 'block', marginBottom: '8px' }}>
                    Estoque Físico: *
                  </label>
                  <input
                    type="number"
                    name="estoqueFisico"
                    value={formData.estoqueFisico}
                    onChange={handleInputChange}
                    required
                    disabled={loading}
                    style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', background: 'white' }}
                  />
                </div>

                <div>
                  <label style={{ color: '#333', fontWeight: 'bold', display: 'block', marginBottom: '8px' }}>
                    Estoque Reservado:
                  </label>
                  <input
                    type="number"
                    name="estoqueReservado"
                    value={formData.estoqueReservado}
                    onChange={handleInputChange}
                    disabled={loading}
                    style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', background: 'white' }}
                  />
                </div>

                <div>
                  <label style={{ color: '#333', fontWeight: 'bold', display: 'block', marginBottom: '8px' }}>
                    Estoque Mínimo:
                  </label>
                  <input
                    type="number"
                    name="estoqueMinimo"
                    value={formData.estoqueMinimo}
                    onChange={handleInputChange}
                    disabled={loading}
                    style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', background: 'white' }}
                  />
                </div>
              </div>
            </div>

            {/* Datas */}
            <div style={{ display: 'flex', gap: '20px', marginBottom: '16px' }}>
              <div style={{ flex: 0.5 }}>
                <label style={{ color: 'black', fontWeight: 'bold', display: 'block', marginBottom: '8px' }}>
                  Data de Cadastro:
                </label>
                <input
                  type="date"
                  name="dataCadastro"
                  value={formData.dataCadastro}
                  onChange={handleInputChange}
                  disabled={loading}
                  style={{
                    width: '150px',
                    padding: '8px',
                    borderRadius: '5px',
                    border: '1px solid #ccc',
                    background: 'white'
                  }}
                />
              </div>

              <div style={{ flex: 0.5 }}>
                <label style={{ color: 'black', fontWeight: 'bold', display: 'block', marginBottom: '8px' }}>
                  Última Movimentação:
                </label>
                <input
                  type="date"
                  name="dataUltimaMovimentacao"
                  value={formData.dataUltimaMovimentacao}
                  onChange={handleInputChange}
                  disabled={loading}
                  style={{
                    width: '150px',
                    padding: '8px',
                    borderRadius: '5px',
                    border: '1px solid #ccc',
                    background: 'white'
                  }}
                />
              </div>
            </div>

            {/* ====== CÓDIGO DE BARRAS ====== */}
            <div style={{ marginBottom: '16px', background: '#f8f9fa', padding: '16px', borderRadius: '8px', border: '1px solid #dee2e6' }}>
              <label style={{ color: 'black', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', userSelect: 'none', marginBottom: 0 }}>
                <input
                  type="checkbox"
                  checked={possuiCodigoBarras}
                  onChange={e => {
                    setPossuiCodigoBarras(e.target.checked);
                    if (!e.target.checked) setFormData(prev => ({ ...prev, codigoBarras: '' }));
                  }}
                  disabled={loading}
                  style={{ width: '17px', height: '17px', cursor: 'pointer', accentColor: 'rgb(235, 133, 0)' }}
                />
                Possui Código de Barras
              </label>
              {possuiCodigoBarras && (
                <div style={{ marginTop: '14px' }}>
                  <input
                    type="text"
                    name="codigoBarras"
                    value={formData.codigoBarras}
                    onChange={handleInputChange}
                    disabled={loading}
                    style={{
                      width: '100%',
                      padding: '9px 14px',
                      borderRadius: '5px',
                      border: '2px solid #ccc',
                      background: 'white',
                      fontSize: '15px',
                      letterSpacing: '2px',
                      boxSizing: 'border-box',
                      fontFamily: 'monospace'
                    }}
                  />
                </div>
              )}
            </div>

            {/* ====== DADOS FISCAIS ====== */}
            <div id="produto-form-fiscal" style={{ marginBottom: '16px', background: '#fffde7', padding: '20px', borderRadius: '8px', border: '1px solid #ffcc80' }}>
              <h4 style={{ color: 'rgb(184, 98, 0)', marginBottom: '16px', fontSize: '16px', fontWeight: 'bold', marginTop: 0 }}>📋 Dados Fiscais (NF-e)</h4>

              {/* NCM + CFOP + CEST */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '14px', marginBottom: '16px' }}>
                <div>
                  <label style={{ color: '#555', fontSize: '13px', fontWeight: 'bold', display: 'block', marginBottom: '6px' }}>NCM <span style={{ color: 'rgb(184, 98, 0)' }}>*</span></label>
                  <input type="text" name="ncm" value={formData.ncm} onChange={handleInputChange} disabled={loading}
                    placeholder="00000000" maxLength={8}
                    style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', background: 'white', fontSize: '13px', boxSizing: 'border-box' }} />
                  <small style={{ color: '#888', fontSize: '11px' }}>Código de 8 dígitos (SEFAZ)</small>
                </div>
                <div>
                  <label style={{ color: '#555', fontSize: '13px', fontWeight: 'bold', display: 'block', marginBottom: '6px' }}>CFOP <span style={{ color: 'rgb(184, 98, 0)' }}>*</span></label>
                  <input type="text" name="cfop" value={formData.cfop} onChange={handleInputChange} disabled={loading}
                    placeholder="5102" maxLength={4}
                    style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', background: 'white', fontSize: '13px', boxSizing: 'border-box' }} />
                  <small style={{ color: '#888', fontSize: '11px' }}>Ex: 5102 venda, 6102 outro estado</small>
                </div>
                <div>
                  <label style={{ color: '#555', fontSize: '13px', fontWeight: 'bold', display: 'block', marginBottom: '6px' }}>CEST <span style={{ color: '#999', fontWeight: 'normal', fontSize: '11px' }}>(só se tiver ST)</span></label>
                  <input type="text" name="cest" value={formData.cest} onChange={handleInputChange} disabled={loading}
                    placeholder="0000000" maxLength={7}
                    style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', background: 'white', fontSize: '13px', boxSizing: 'border-box' }} />
                  <small style={{ color: '#888', fontSize: '11px' }}>Código de 7 dígitos</small>
                </div>
              </div>

              {/* Unid. Tributária + Origem + UF (só se nacional) */}
              {(() => {
                const ehNacional = ['0','3','4','5','8'].includes(String(formData.origemMercadoria));
                return (
                  <div style={{ display: 'grid', gridTemplateColumns: ehNacional ? '1fr 2fr 1fr' : '1fr 2fr', gap: '14px', marginBottom: '16px' }}>
                    <div>
                      <label style={{ color: '#555', fontSize: '13px', fontWeight: 'bold', display: 'block', marginBottom: '6px' }}>Unid. Tributária</label>
                      <select name="unidadeTributaria" value={formData.unidadeTributaria} onChange={handleInputChange} disabled={loading}
                        style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', background: 'white', fontSize: '13px' }}>
                        <option value="UN">UN</option><option value="KG">KG</option><option value="G">G</option>
                        <option value="L">L</option><option value="ML">ML</option><option value="M">M</option>
                        <option value="M2">M²</option><option value="M3">M³</option><option value="CX">CX</option>
                        <option value="PC">PC</option><option value="PAR">PAR</option><option value="TON">TON</option>
                      </select>
                    </div>
                    <div>
                      <label style={{ color: '#555', fontSize: '13px', fontWeight: 'bold', display: 'block', marginBottom: '6px' }}>Origem da Mercadoria <span style={{ color: 'rgb(184, 98, 0)' }}>*</span></label>
                      <select name="origemMercadoria" value={formData.origemMercadoria} onChange={handleInputChange} disabled={loading}
                        style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', background: 'white', fontSize: '13px' }}>
                        <option value="0">0 – Nacional (produção própria)</option>
                        <option value="1">1 – Estrangeira (importação direta)</option>
                        <option value="2">2 – Estrangeira (adquirida no mercado interno)</option>
                        <option value="3">3 – Nacional, conteúdo importado 40% a 70%</option>
                        <option value="4">4 – Nacional, produção conforme processos produtivos</option>
                        <option value="5">5 – Nacional, conteúdo importado inferior a 40%</option>
                        <option value="6">6 – Estrangeira (importação direta, sem similar nacional)</option>
                        <option value="7">7 – Estrangeira (mercado interno, sem similar nacional)</option>
                        <option value="8">8 – Nacional, conteúdo importado superior a 70%</option>
                      </select>
                    </div>
                    {ehNacional && (
                      <div>
                        <label style={{ color: '#555', fontSize: '13px', fontWeight: 'bold', display: 'block', marginBottom: '6px' }}>UF de Produção</label>
                        <select name="ufProducao" value={formData.ufProducao} onChange={handleInputChange} disabled={loading}
                          style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', background: 'white', fontSize: '13px' }}>
                          <option value="">Selecione...</option>
                          <option value="AC">AC</option><option value="AL">AL</option><option value="AP">AP</option>
                          <option value="AM">AM</option><option value="BA">BA</option><option value="CE">CE</option>
                          <option value="DF">DF</option><option value="ES">ES</option><option value="GO">GO</option>
                          <option value="MA">MA</option><option value="MT">MT</option><option value="MS">MS</option>
                          <option value="MG">MG</option><option value="PA">PA</option><option value="PB">PB</option>
                          <option value="PR">PR</option><option value="PE">PE</option><option value="PI">PI</option>
                          <option value="RJ">RJ</option><option value="RN">RN</option><option value="RS">RS</option>
                          <option value="RO">RO</option><option value="RR">RR</option><option value="SC">SC</option>
                          <option value="SP">SP</option><option value="SE">SE</option><option value="TO">TO</option>
                        </select>
                      </div>
                    )}
                  </div>
                );
              })()}

              {/* GTIN auto-preenchido pelo código de barras */}
              <div style={{ marginBottom: '16px', padding: '10px 14px', borderRadius: '6px', background: possuiCodigoBarras && formData.codigoBarras ? '#e8f5e9' : '#f5f5f5', border: `1px solid ${possuiCodigoBarras && formData.codigoBarras ? '#a5d6a7' : '#e0e0e0'}` }}>
                <span style={{ fontSize: '13px', color: '#555' }}>
                  <strong>GTIN (NF-e):</strong>{' '}
                  {possuiCodigoBarras && formData.codigoBarras
                    ? <span style={{ fontFamily: 'monospace', fontWeight: 'bold', color: '#2e7d32' }}>{formData.codigoBarras}</span>
                    : <span style={{ color: '#aaa', fontStyle: 'italic' }}>Preenchido automaticamente quando o código de barras for informado acima</span>
                  }
                </span>
              </div>

              {/* Regime Tributário */}
              <div style={{ marginBottom: '16px' }}>
                <label style={{ color: '#555', fontSize: '13px', fontWeight: 'bold', display: 'block', marginBottom: '6px' }}>Regime Tributário <span style={{ color: 'rgb(184, 98, 0)' }}>*</span></label>
                <select name="regimeTributario" value={formData.regimeTributario} onChange={handleInputChange} disabled={loading}
                  style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', background: 'white', fontSize: '13px' }}>
                  <option value="simples">Simples Nacional</option>
                  <option value="normal">Lucro Real / Lucro Presumido (Regime Normal)</option>
                </select>
              </div>

              {/* Códigos de Tributação */}
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '14px', marginBottom: '16px' }}>
                <div>
                  <label style={{ color: '#555', fontSize: '13px', fontWeight: 'bold', display: 'block', marginBottom: '6px' }}>
                    {formData.regimeTributario === 'simples' ? 'CSOSN (Simples Nacional)' : 'CST ICMS (Regime Normal)'}
                  </label>
                  {formData.regimeTributario === 'simples' ? (
                    <select name="csosn" value={formData.csosn} onChange={handleInputChange} disabled={loading}
                      style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', background: 'white', fontSize: '12px' }}>
                      <option value="101">101 – Com permissão de crédito</option>
                      <option value="102">102 – Sem permissão de crédito</option>
                      <option value="103">103 – Isenção ICMS nas operações</option>
                      <option value="201">201 – Com permissão + ST</option>
                      <option value="202">202 – Sem permissão + ST</option>
                      <option value="203">203 – Isenção + ST</option>
                      <option value="300">300 – Imune</option>
                      <option value="400">400 – Não tributada</option>
                      <option value="500">500 – ICMS cobrado por ST</option>
                      <option value="900">900 – Outros</option>
                    </select>
                  ) : (
                    <select name="cst_ICMS" value={formData.cst_ICMS} onChange={handleInputChange} disabled={loading}
                      style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', background: 'white', fontSize: '12px' }}>
                      <option value="00">00 – Tributada integralmente</option>
                      <option value="10">10 – Tributada com ST</option>
                      <option value="20">20 – Com redução de BC</option>
                      <option value="30">30 – Isenta/não trib. c/ ST</option>
                      <option value="40">40 – Isenta</option>
                      <option value="41">41 – Não tributada</option>
                      <option value="50">50 – Suspensão</option>
                      <option value="51">51 – Diferimento</option>
                      <option value="60">60 – ICMS cobrado anteriormente por ST</option>
                      <option value="70">70 – Redução de BC e ST</option>
                      <option value="90">90 – Outras</option>
                    </select>
                  )}
                </div>
                <div>
                  <label style={{ color: '#555', fontSize: '13px', fontWeight: 'bold', display: 'block', marginBottom: '6px' }}>CST IPI</label>
                  <select name="cst_IPI" value={formData.cst_IPI} onChange={handleInputChange} disabled={loading}
                    style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', background: 'white', fontSize: '12px' }}>
                    <option value="50">50 – Saída tributada</option>
                    <option value="51">51 – Saída tributada alíq. zero</option>
                    <option value="52">52 – Saída isenta</option>
                    <option value="53">53 – Saída não tributada</option>
                    <option value="54">54 – Saída imune</option>
                    <option value="55">55 – Saída com suspensão</option>
                    <option value="99">99 – Outras saídas</option>
                    <option value="00">00 – Entrada com recuperação</option>
                    <option value="02">02 – Entrada isenta</option>
                    <option value="03">03 – Entrada não tributada</option>
                    <option value="04">04 – Entrada imune</option>
                    <option value="49">49 – Outras entradas</option>
                  </select>
                </div>
                <div>
                  <label style={{ color: '#555', fontSize: '13px', fontWeight: 'bold', display: 'block', marginBottom: '6px' }}>CST PIS / COFINS</label>
                  <select name="cst_PIS" value={formData.cst_PIS}
                    onChange={e => setFormData(prev => ({ ...prev, cst_PIS: e.target.value, cst_COFINS: e.target.value }))}
                    disabled={loading}
                    style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', background: 'white', fontSize: '12px' }}>
                    <option value="01">01 – Tributável (BC = valor)</option>
                    <option value="02">02 – Tributável (BC = quantidade)</option>
                    <option value="04">04 – Tributável (ST)</option>
                    <option value="06">06 – Alíquota zero</option>
                    <option value="07">07 – Isenta</option>
                    <option value="08">08 – Sem incidência</option>
                    <option value="09">09 – Suspensão</option>
                    <option value="49">49 – Outras saídas</option>
                    <option value="99">99 – Outras operações</option>
                  </select>
                  <small style={{ color: '#888', fontSize: '11px' }}>Mesmo código para PIS e COFINS</small>
                </div>
              </div>

              {/* Benefício Fiscal + Informações Adicionais */}
              <div style={{ marginBottom: '16px' }}>
                <label style={{ color: '#555', fontSize: '13px', fontWeight: 'bold', display: 'block', marginBottom: '6px' }}>Benefício Fiscal <span style={{ color: '#999', fontWeight: 'normal', fontSize: '11px' }}>(opcional)</span></label>
                <input type="text" name="beneficioFiscal" value={formData.beneficioFiscal} onChange={handleInputChange} disabled={loading}
                  placeholder="Código do benefício"
                  style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', background: 'white', fontSize: '13px', boxSizing: 'border-box' }} />
              </div>

              <div style={{ marginBottom: 0 }}>
                <label style={{ color: '#555', fontSize: '13px', fontWeight: 'bold', display: 'block', marginBottom: '6px' }}>Informações Adicionais</label>
                <textarea name="informacoesAdicionaisProduto" value={formData.informacoesAdicionaisProduto} onChange={handleInputChange} disabled={loading}
                  rows="2" placeholder="Informações adicionais que aparecerão na NF-e"
                  style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', background: 'white', fontSize: '13px' }} />
              </div>
            </div>

            {/* ====== PESO E MEDIDAS ====== */}
            <div id="produto-form-medidas" style={{ marginBottom: '16px', background: '#f8f9fa', padding: '16px', borderRadius: '8px', border: '1px solid #dee2e6' }}>
              <h4 style={{ color: 'black', marginBottom: '14px', fontSize: '15px', fontWeight: 'bold', marginTop: 0 }}>⚖️ Peso e Medidas</h4>

              {/* Peso — sempre visível */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
                <div>
                  <label style={{ color: '#555', fontSize: '13px', fontWeight: 'bold', display: 'block', marginBottom: '6px' }}>Peso Líquido (kg):</label>
                  <input type="number" step="0.001" name="pesoLiquido" value={formData.pesoLiquido} onChange={handleInputChange} disabled={loading}
                    style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', background: 'white', fontSize: '14px' }} />
                </div>
                <div>
                  <label style={{ color: '#555', fontSize: '13px', fontWeight: 'bold', display: 'block', marginBottom: '6px' }}>Peso Bruto (kg):</label>
                  <input type="number" step="0.001" name="pesoBruto" value={formData.pesoBruto} onChange={handleInputChange} disabled={loading}
                    style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', background: 'white', fontSize: '14px' }} />
                </div>
              </div>

              {/* Dimensões — com checkbox */}
              <label style={{ color: '#555', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', userSelect: 'none', fontSize: '13px', marginBottom: 0 }}>
                <input
                  type="checkbox"
                  checked={adicionarMedidas}
                  onChange={e => {
                    setAdicionarMedidas(e.target.checked);
                    if (!e.target.checked) setFormData(prev => ({ ...prev, altura: '', largura: '', profundidade: '' }));
                  }}
                  disabled={loading}
                  style={{ width: '17px', height: '17px', cursor: 'pointer', accentColor: 'rgb(235, 133, 0)' }}
                />
                Adicionar medidas da nota fiscal
              </label>

              {adicionarMedidas && (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px', marginTop: '14px' }}>
                  <div>
                    <label style={{ color: '#555', fontSize: '13px', fontWeight: 'bold', display: 'block', marginBottom: '6px' }}>Altura (cm):</label>
                    <input type="number" step="0.01" name="altura" value={formData.altura} onChange={handleInputChange} disabled={loading}
                      style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', background: 'white', fontSize: '14px' }} />
                  </div>
                  <div>
                    <label style={{ color: '#555', fontSize: '13px', fontWeight: 'bold', display: 'block', marginBottom: '6px' }}>Largura (cm):</label>
                    <input type="number" step="0.01" name="largura" value={formData.largura} onChange={handleInputChange} disabled={loading}
                      style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', background: 'white', fontSize: '14px' }} />
                  </div>
                  <div>
                    <label style={{ color: '#555', fontSize: '13px', fontWeight: 'bold', display: 'block', marginBottom: '6px' }}>Comprimento (cm):</label>
                    <input type="number" step="0.01" name="profundidade" value={formData.profundidade} onChange={handleInputChange} disabled={loading}
                      style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', background: 'white', fontSize: '14px' }} />
                  </div>
                </div>
              )}
            </div>

            {/* Status do Produto */}
            <div style={{ marginBottom: '16px' }}>
              <label style={{ color: 'black', fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>
                <input
                  type="checkbox"
                  name="ativo"
                  checked={formData.ativo}
                  onChange={handleInputChange}
                  disabled={loading}
                  style={{ marginRight: '8px' }}
                />
                Produto Ativo
              </label>
            </div>

            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
              <button
                type="submit"
                disabled={loading}
                style={{
                  background: loading ? '#ccc' : 'rgb(235, 133, 0)',
                  color: 'white',
                  border: 'none',
                  padding: '10px 20px',
                  borderRadius: '4px',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  fontSize: '14px'
                }}
              >
                {loading ? 'Salvando...' : (produto ? 'Atualizar' : 'Criar')} Produto
              </button>
              <button
                type="button"
                onClick={handleCancelar}
                disabled={loading}
                style={{
                  background: '#6c757d',
                  color: 'white',
                  border: 'none',
                  padding: '10px 20px',
                  borderRadius: '4px',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  fontSize: '14px'
                }}
              >
                Cancelar
              </button>
            </div>
          </form>

          {/* category management was moved to the fixed Categorias sidebar; no internal modal here */}
        </div>
      </div>
    </div>
  );
}
